import { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [selectedQuestion, setSelectedQuestion] = useState("3");

  const [minRating, setMinRating] = useState(1600);
  const [maxRating, setMaxRating] = useState(2000);
  const [limit, setLimit] = useState(10);
  const [hideRating, setHideRating] = useState(false);

  return (
    <AppContext.Provider
      value={{
        selectedQuestion,
        setSelectedQuestion,
        minRating,
        setMinRating,
        maxRating,
        setMaxRating,
        limit,
        setLimit,
        hideRating,
        setHideRating,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);